'use strict';

angular.module('utils').factory('OCClinicUtil', function($rootScope, ClinicService, CurrentUser, OpencareConstants, OCModalUtil) {
  var self = {
    claimClinic: function(clinicId, verificationCode) {
      return ClinicService.claimClinic(CurrentUser.getCompany().id, clinicId, verificationCode);
    },

    getProviderSpecialties: function(clinic) {
      return _.chain(clinic.providers).map(function(provider) {
        return _.get(provider, 'doctor.specialties', []);
      })
        .flatten()
        .value();
    },

    isReservedSlotPromotionEnabled: function(clinic, date) {
      return !!_.get(clinic, 'metadata.reservedSlotPromotion') && moment(date).isBetween(OpencareConstants.reservedSlotPromotion.from, OpencareConstants.reservedSlotPromotion.to, null, '[]');
    },

    hasPrimeDentalProviders: function(clinic) {
      return _.some(clinic.providers, function(provider) {
        return provider.onlineBooking && _.some(provider.doctor.specialties, {
          id: OpencareConstants.specialtyId.DENTIST,
        });
      });
    },

    hasOpencareSyncProviders: function(clinic) {
      return _.some(clinic.providers, function(provider) {
        return _.get(provider, 'syncEnabled');
      });
    },

    hasLocalmedProviders: function(clinic) {
      return _.some(clinic.providers, function(provider) {
        return _.get(provider, 'metadata.localMedSettings.providerId');
      });
    },

    isCanadianClinic: function(clinic) {
      return _.get(clinic, 'address.country') == 'Canada';
    },

    isInstantBookSyncPractice: function(clinic) {
      return self.hasOpencareSyncProviders(clinic) || self.hasLocalmedProviders(clinic);
    },

    isClinicLive: function(clinic) {
      return _.some(clinic.providers, {
        onlineBooking: true,
      });
    },

    showIbHealthResyncModal: function(clinic) {
      const calendlyLink = OpencareConstants.calendly.calendarResync + '?utm_source=' + clinic.id;

      OCModalUtil.showCustomModal({
        windowClass: 'ib-health-resync',
        templateUrl: '/views/modals/_ib-health-resync-modal.html',
        controller: 'IBHealthResyncModal',
        backdrop: 'static',
        resolve: OCModalUtil.createResolve({
          calendlyLink,
        }),
      }).then(function() {
        ClinicService.getClinic(clinic.id).then((updatedClinic) => {
          const shouldShowIBHealthResyncBanner = !self.hasResyncCallBooked(updatedClinic);

          if (shouldShowIBHealthResyncBanner) {
            $rootScope.showResyncAlertBanner = true;
            $rootScope.calendlyLink = calendlyLink;
          } else {
            $rootScope.showResyncAlertBanner = false;
          }
        });
      });
    },

    /**
     * Checks whether the IB Health Resync Modal should be shown for a clinic.
     * The modal should be shown if:
     * 1) The last calendar sync date was more than 14 days ago, AND
     * 2) The clinic is an instant book sync practice.
     *
     * @param {Object} clinic - The clinic to check.
     * @returns {boolean} - Returns `true` if the IB Health Resync Modal should be shown, `false` otherwise.
     */
    shouldShowIBHealthResyncModal: function(clinic) {
      return self.hasNotSyncedIn14Days(clinic) || clinic.metadata.showIBResyncModal;
    },

    hasResyncCallBooked: function(clinic) {
      var resyncCallDate = clinic.metadata.resyncCallDate;
      var wasResyncCallOverAMonthAgo = moment(resyncCallDate).isBefore(moment().subtract(1, 'month'));
      return resyncCallDate && !wasResyncCallOverAMonthAgo;
    },

    /**
     * Checks whether the last calendar sync for a clinic was more than 14 days ago.
     * @param {Object} clinic - The clinic to check. It's expected to have an `ocsMetadata` property
     *                          which contains a `lastCalendarSync` date.
     * @returns {boolean} - Returns `true` if the last calendar sync was more than 14 days ago, `false` otherwise, null if never has synced.
     */
    hasNotSyncedIn14Days: function(clinic) {
      let lastSyncDate = clinic?.ocsMetadata?.lastCalendarSync;
      if (!lastSyncDate) {
        return null;
      }

      let wasLastSyncOver14DaysAgo = moment.utc(lastSyncDate).isBefore(moment.utc().subtract(14, 'days'));
      return wasLastSyncOver14DaysAgo;
    },

    /**
     * Determines if a clinic was onboarded via the Public onboard funnel and subsequently skipped the billing step.
     *
     * @param {Object} user - The user object to inspect.
     * @property {Object[]} user.editable.clinics - Array of clinics associated with the user.
     * @property {boolean} user.metadata.publicClinicOnboarding - Indicates if the clinic was onboarded via the Public onboard funnel.
     * @property {boolean} user.metadata.publicClinicOnboardingFinished - Indicates if the onboarding process was completed.
     * @property {Object[]} user.stripeCards - Array of Stripe cards associated with the user.
     *
     * @returns {boolean} Returns `true` if the clinic was onboarded via the Public onboard funnel, completed the onboarding, but skipped the billing step and has at least one provider.
     */
    isOnboardPublicAndSkippedBilling: function(user) {
      const isOnboarded = _.get(user, 'metadata.publicClinicOnboarding');
      const isOnboardingFinished = ![null, undefined].includes(_.get(user, 'metadata.publicClinicOnboardingFinished'));
      const hasDoctors = _.get(user, 'editable.doctors', []).length > 0;

      return isOnboarded && isOnboardingFinished && hasDoctors;
    },
  };

  return self;
});
